import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { Observable, of } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/do';
//import 'rxjs/add/operator/catch';
import { IPagination } from '../_interfaces/pagination'
import { IHersteller } from '../_interfaces/hersteller';
import { IChoiceList } from '../_interfaces/_choice-list';
import * as moment from 'moment'; // DateTimeOffset-Fix
import * as cloneDeep from 'lodash/cloneDeep'; // DateTimeOffset-Fix

import { AppconfigService } from '../_services/appconfig.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';

@Injectable()
export class HerstellerService extends CRUDBasicService {

  //typeOf deprecated -> CRUDBasicService.propertyTypeOf
  /*typeOf(propertyName: string) {  // welchen Typs sind die Properties IN DER API ?
    let property = this.propertyTypes.find(f => f.name == propertyName);
    if(property != null) return property.type;
    else return null;    
  }*/
  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    {name: 'hersteller', type: 'string'},
    {name: 'bezeichnung', type: 'string'},
    {name: 'createdBy', type: 'string'},
    {name: 'created', type: 'DateTimeOffset'},
    {name: 'modifiedBy', type: 'string'},
    {name: 'modified', type: 'DateTimeOffset'},
    {name: 'rowVersion', type: 'byte[]'},
    {name: 'summary', type: 'string'}
  ];
    
  getHerstellerCollection(pageNumber: number, pageSize: number, searchQuery: string): Observable<{ hersteller: IHersteller[], pagination: IPagination }> {
    return this.httpClient.get(this.apiBaseUrl + 'herstellertabelle?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&searchQuery=' + searchQuery, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        map((response) => {
          return { hersteller: <IHersteller[]>response.body, 
            pagination: /*<IPagination>JSON.parse(response.headers.get('x-pagination'))*/this.getDummyPagination((<any[]>response.body).length)
          };
        }), catchError(this.handleError))
  }

    getHersteller(id: string): Observable<IHersteller> {
  
      if (id === null) {
        // return Observable.create((observer: any) => {
        //   observer.next(this.initializeAnstrich());
        //   observer.complete();
        // })
        console.log("HerstellerService.getHersteller() id === null. return empty object.");
        return of(this.initializeHersteller());
      }
  
      return this.httpClient.get<IHersteller>(this.apiBaseUrl + 'herstellertabelle/?hersteller=' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
        .pipe(map((response) => 
          //response
          {
            return response[0];
          }
        ), catchError(this.handleError));
    }
  
  initializeHersteller(): IHersteller {
    return {
      hersteller: '',
      bezeichnung: '',
      createdBy: '',
      created: '',
      modifiedBy: '',
      modified: '',
      rowVersion: '',
      summary: ''
    };
  }


}
